import { auth } from '@/src/firebase';
import axios from 'axios'; 

const apiUrl = process.env['NX_API_URL'];

export const fetchAttachmentFile = async (
  attachmentID: number,
  signal?: AbortSignal
) => {
  const response = await axios.get(
    `${apiUrl}/api/attachments/${attachmentID}`,
    {
      signal,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
      },
    }
  );

  return response;
};

export const fetchAttachmentFiles = async (
  attachments: { id: number; name?: string }[],
  zipFilename: string,
  signal?: AbortSignal
) => {
  const response = await axios.get(`${apiUrl}/api/attachments/idList`, {
    signal,
    params: { attachments, zipFilename },
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });

  return response;
};

export type postGeneratePDFArgs = {
  html: string;
  format: string;
  isPdfPortrait: boolean;
  width: number;
  cssFileName?: string;
};

export const postGeneratePDF = async (
  body: postGeneratePDFArgs,
  signal?: AbortSignal
) => {
  const response = await axios.post(`${apiUrl}/api/attachments/pdf`, body, {
    signal,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
    responseType: 'blob',
  });

  const result = response.data;
  return result;
};

export const fetchAttachmentsIDs = async (
  companyID: string,
  uniqueAttchID: string,
  latest?: boolean
) => {
  const response = await axios.get(`${apiUrl}/api/attachments`, {
    params: { companyID, uniqueAttchID, latest },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${await auth.currentUser?.getIdToken()}`,
    },
  });
  const result = response.data;
  return result;
};
